export const YesOrNoNum = {
  Yes: 1,
  No: 0,
}

export const YesOrNoStr = {
  Yes: '1',
  No: '0',
}
